import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import * as BackstageConstants from '../../../constants';
import * as D from '../../../deps';

const ArtistFeaturedContentGridItem = props => {
  const { id, pandoraId, pandoraType, isCollected, shareableUrlPath } = props;

  return (
    <D.AppContextIntegrationData
      data={{
        contentSection:
          D.Constants.ContentSections.BackstageContentSections.ARTIST_BACKSTAGE_FEATURED_CONTENT,
        pandoraId,
      }}
    >
      <D.MixedGridItem
        id={id}
        pandoraId={pandoraId}
        pandoraType={pandoraType}
        isCollected={isCollected}
        shareableUrlPath={shareableUrlPath}
      />
    </D.AppContextIntegrationData>
  );
};

ArtistFeaturedContentGridItem.propTypes = {
  id: PropTypes.string,
  pandoraId: PropTypes.string,
  pandoraType: PropTypes.string,
  isCollected: PropTypes.bool,
  shareableUrlPath: PropTypes.string,
};

function createFeaturedContentProps(state, props, merger) {
  return Object.assign({}, props, merger(state, props));
}

function mergeStationProps(state, props) {
  const { id } = props;
  const annotation = D.Utils.Entity.getAnnotationsById(state, id) || BackstageConstants.emptyMap;
  const stationId = D.getInDomain('playback.utils.getStationIdFromStationFactoryId', null)(
    state,
    id,
  );
  const shareableUrlPath =
    annotation.get('seedType') === D.Constants.SourceTypes.PandoraTypes.GENRE
      ? annotation.get('shareableUrlPath')
      : null;

  return {
    id: stationId,
    shareableUrlPath,
  };
}

function mergeAdditionalProps(state, props) {
  const { pandoraType } = props;
  return pandoraType === D.Constants.SourceTypes.PandoraTypes.STATION
    ? mergeStationProps(state, props)
    : {};
}

export function mapStateToProps(state, ownProps) {
  const { pandoraId } = ownProps;
  return createFeaturedContentProps(
    state,
    {
      id: pandoraId,
      pandoraType: D.Utils.SourceType.getPandoraTypeFromPandoraId(pandoraId),
      isCollected: D.getInDomain('collection.utils.isPandoraIdInCollection', false)(
        state,
        pandoraId,
      ),
    },
    mergeAdditionalProps,
  );
}

export default connect(mapStateToProps)(ArtistFeaturedContentGridItem);
